"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useTokenMetas_1 = __importDefault(require("./useTokenMetas"));
const buildTokenMeta_1 = __importDefault(require("../utils/buildTokenMeta"));
function useTokensUpdate(params) {
    const { tokenValues, onTokenValueValidate } = params;
    const { tokenMetas, setTokenMetas, setTokenActivated } = (0, useTokenMetas_1.default)();
    const [hasInvalidToken, setHasInvalidToken] = (0, react_1.useState)(false);
    const [internalTokenValues, setInternalTokenValues] = (0, react_1.useState)([]);
    (0, react_1.useLayoutEffect)(() => {
        let hasInvalid = false;
        const newTokenMetas = tokenValues.map((tokenValue, index) => {
            const error = onTokenValueValidate(tokenValue, index, tokenValues);
            const newTokenMeta = (0, buildTokenMeta_1.default)(error, tokenValue, index);
            if (newTokenMeta.error && !newTokenMeta.activated) {
                hasInvalid = true;
            }
            return newTokenMeta;
        });
        setInternalTokenValues([...tokenValues]);
        setTokenMetas(newTokenMetas);
        setHasInvalidToken(hasInvalid);
    }, [tokenValues, onTokenValueValidate, setTokenMetas]);
    return {
        hasInvalidToken,
        internalTokenValues,
        tokenMetas,
        setTokenActivated,
    };
}
exports.default = useTokensUpdate;
